/** flash.geom.Point (semantics mirror Flash Player / Ruffle's Point.as). */
export class Point {
  x: number;
  y: number;

  constructor(x: number = 0, y: number = 0) {
    this.x = +x;
    this.y = +y;
  }

  get length(): number {
    return Math.sqrt(this.x * this.x + this.y * this.y);
  }

  add(v: Point): Point {
    return new Point(this.x + v.x, this.y + v.y);
  }

  subtract(v: Point): Point {
    return new Point(this.x - v.x, this.y - v.y);
  }

  clone(): Point {
    return new Point(this.x, this.y);
  }

  copyFrom(p: Point): void {
    this.x = p.x;
    this.y = p.y;
  }

  setTo(x: number, y: number): void {
    this.x = x;
    this.y = y;
  }

  equals(p: Point): boolean {
    return this.x === p.x && this.y === p.y;
  }

  offset(dx: number, dy: number): void {
    this.x += dx;
    this.y += dy;
  }

  normalize(thickness: number): void {
    const len = this.length;
    if (len > 0) {
      const inv = thickness / len;
      this.x *= inv;
      this.y *= inv;
    }
  }

  toString(): string {
    return `(x=${this.x}, y=${this.y})`;
  }

  static distance(a: Point, b: Point): number {
    return b.subtract(a).length;
  }

  /** f = 1 returns `a`, f = 0 returns `b` (Flash semantics). */
  static interpolate(a: Point, b: Point, f: number): Point {
    return new Point(b.x - (b.x - a.x) * f, b.y - (b.y - a.y) * f);
  }

  static polar(len: number, angle: number): Point {
    return new Point(len * Math.cos(angle), len * Math.sin(angle));
  }
}
